module.exports = __webpack_public_path__ + "static/media/v9.1e6da5c8.mp4";